    <template>
        <customModal :containermd="true" @closeModal="closeModal">
               <template #title>
        {{ isEditMode ? $t('navigations.update arm') : $t('navigations.create arm') }}
    </template>

            <template #body>
                <div class="row">
                    <div class="col-md-6 form-group mb-2">
                        <label class="mb-0">{{ $t("navigations.arm name") }}<sup><i
                                    class="fa fa-asterisk required"></i></sup></label>
                        <input v-model="newArm.armName" class="form-control" type="text"
                             />
                             <span v-if="errors.armName" class="errormsg ml-0">
                {{ errorMessages.armName }}
            </span>
                    </div>

                    <div class="col-md-6 form-group mb-2">
                        <label class="mb-0"> {{ $t("navigations.arm code") }}<sup><i
                                    class="fa fa-asterisk required"></i></sup></label>
                        <input v-model="newArm.armCode" class="form-control" type="text" />
                         <span v-if="errors.armCode" class="errormsg ml-0">
                {{ errorMessages.armCode }}
            </span>
                        
                    </div>
                         <div class="col-md-6 form-group mb-2">
                        <label class="mb-0">{{ $t("navigations.arm type") }}</label>
                        <input v-model="newArm.armType" class="form-control" type="text"
                             />
          
                    </div>
                     <div class="col-lg-6 my-0">
          <label class="col-form-label">SoA ID</label>
         <select class="form-select" v-model="newArm.SoAId">
            <option disabled :value="null">
              {{ $t("navigations.select") }}
            </option>

            <option v-for="soa in studySoAList" :key="soa.value" :value="soa.value">
              {{ soa.label }}
            </option>
          </select>
        </div>

                </div>
                <div class="form-group mb-2">
                    <label class="mb-0">{{ $t("navigations.description") }}</label>
                    <textarea v-model="newArm.description" class="form-control" rows="2" />
                    
                </div>

                <div class="form-group mb-2">
                    <label>
                        <input type="checkbox" v-model="newArm.active" class="mr-1" /> {{ $t("navigations.active") }}
                    </label>
                </div>

                <div class="text-right">
                    <button class="save_btn py-0 px-4 position-relative" @click="submitNewArm">
                        {{ isEditMode ? 'Update' : 'Create' }}
                    </button>
                </div>
            </template>
        </customModal>
    </template>
<script src="./ArmModal.js"></script>